import { checkboxCardSlotRecipe as base } from '@chakra-ui/react/theme';

import { formSelectionLabel, formSelectionSurface } from '../form-selection';
import { pressFeedback } from '../pressFeedback';

const baseVariants = base.variants as Record<string, Record<string, unknown>>;

export const checkboxCardSlotRecipe = {
  ...base,
  base: {
    ...base.base,
    root: {
      ...base.base?.root,
      ...pressFeedback,
      minH: '11',
      _disabled: { ...base.base?.root?._disabled, ...pressFeedback._disabled },
    },
  },
  variants: {
    ...base.variants,
    variant: {
      ...baseVariants.variant,
      pill: {
        root: {
          flex: '0',
          borderRadius: 'full',
          borderWidth: '1px',
          borderColor: 'transparent',
          bg: 'whiteAlpha.50',
          color: 'fg.secondary',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: pressFeedback.transition,
          focusVisibleRing: 'outside',
          _hover: { bg: 'whiteAlpha.100', color: 'white' },
          _checked: {
            ...formSelectionSurface,
            _hover: {
              bg: 'bg.selectedHover',
            },
          },
        },
        control: {
          flex: '1',
          px: 3,
          py: 1.5,
          gap: 1.5,
          alignItems: 'center',
        },
        indicator: {
          display: 'none',
        },
        label: {
          ...formSelectionLabel,
        },
        content: {
          ...formSelectionLabel,
        },
      },
    },
  },
};
